import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type LinkWarehouseRequest as SchemaLinkWarehouseRequest } from '../schemas/LinkWarehouseRequest';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const LinkWarehousesContentType = 'application/json' as const;
export type LinkWarehousesRequest = SchemaLinkWarehouseRequest;
export type LinkWarehousesResponses = LinkCommonErrorResponses & {
    '200': {
        'application/json': unknown;
    };
};
export type LinkWarehousesResponseSuccess = LinkWarehousesResponses['200']['application/json'];
export type LinkWarehousesSearchParams = undefined;
export type LinkWarehousesPathParameters = undefined;
export const LinkWarehousesUrl = '/warehouses/link' as const;
export const LinkWarehousesMethod = 'POST' as const;
export const getLinkWarehousesUrl = (_params?: LinkWarehousesPathParameters) => LinkWarehousesUrl;
